import { render, staticRenderFns } from "./TabellaValori.vue?vue&type=template&id=ec8334b2&scoped=true"
import script from "./TabellaValori.vue?vue&type=script&lang=ts"
export * from "./TabellaValori.vue?vue&type=script&lang=ts"
import style0 from "./TabellaValori.vue?vue&type=style&index=0&id=ec8334b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8334b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec8334b2')) {
      api.createRecord('ec8334b2', component.options)
    } else {
      api.reload('ec8334b2', component.options)
    }
    module.hot.accept("./TabellaValori.vue?vue&type=template&id=ec8334b2&scoped=true", function () {
      api.rerender('ec8334b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consumi/TabellaValori.vue"
export default component.exports